import React from "react";
import PropTypes from "prop-types";
import Button from "./Button";
import { Link } from "react-router-dom";
import { UserConsumer } from "./Context";
import { useEffect, useState } from "react";
import LanguageOptionDropdown from "./LanguageOptionDropdown";
import { useTranslation } from "react-i18next";

const Header = ({
  logo,
  isWithEmbed,
  aboutButton,
  embedButton,
  instructionButton,
  langSwitcher,
  editMember,
  finishSession,
  color,
  background,
  visibility,
  display,
  onOpenPassword,
  isPlaying,
  usePassword,
  login
}) => {
  const logo_header = window.welcome.logo_welcome;
  const [isLogin, setLogin] = useState(false);
  const { t } = useTranslation();
  const Login = () => {
    if (usePassword === true && !login) setLogin(true);
  };
  // @ts-ignore
  const languageCodes = window.wpml_language_codes?.language_codes || [];

  useEffect(() => {
    Login();
  });
  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-left-side">
          { logo_header ? (
            <img className="header-logo" alt="logo" src={logo_header} />
          ) : (
            <div />
          )}
          
          {/* <div
            className="header-lang-switcher"
            dangerouslySetInnerHTML={{ __html: langSwitcher }}
          /> */}
        </div>

        <div className="header-actions">

          {languageCodes.length > 1 && <LanguageOptionDropdown />}

          <Button {...aboutButton} />

          {/* <Button
            {...instructionButton}
            className="btn-action"
            iconFA="book-open"
            iconPosition="start"
            color={color}
            // background={background}
            title="Introduction Page"
            visibility={visibility}
          /> */}

          {}

          <UserConsumer>
            {value => (
              <Link
                className="finish-session-button"
                to={isLogin ? "/password-page" : "/"}
                state={{ value }}
              >
                <Button
                  {...editMember}
                  className="btn-action"
                  iconFA="users"
                  iconPosition="start"
                  color={color}
                  // background={background}
                  title={t("Team Page")}
                  visibility={visibility}
                />
              </Link>
            )}
          </UserConsumer>

          <UserConsumer>
            {value => (
              <Link
                className="finish-session-button"
                to="/end-page"
                state={{ value }}
              >
                <Button
                  {...finishSession}
                  className="btn-action"
                  iconFA="edit"
                  iconPosition="start"
                  visibility={visibility}
                  display={display}
                  title={t("Finish this Session")}
                />
              </Link>
            )}
          </UserConsumer>

          {/* {isWithEmbed && (
            <Button
              {...embedButton}
              iconFA="share-alt"
              iconPosition="end"
              color={color}
              background={background}
            />
          )} */}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  logo: PropTypes.string,
  isWithEmbed: PropTypes.bool,
  aboutButton: PropTypes.shape(Button.propTypes),
  embedButton: PropTypes.shape(Button.propTypes)
};

Header.defaultProps = {
  isWithEmbed: false
};

export default Header;
